export default __webpack_public_path__ + "static/media/app-bar-save.28c0fb09.svg";